var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.conversion)?_c('Valuation',{attrs:{"valuation":_vm.conversion.valuation,"lead-data":_vm.conversion.personalData,"origin":_vm.conversion.origin,"source":_vm.conversion.source}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }